import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Payment, WorkOutline } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { ProjectSummary, SubcontractorDetails, SubcontractorStatement } from "../../components/subcontractor";
import { PageHeader } from "../../components/v3";
import { CREATE_CONTRACT, VIEW_CONTRACT, CREATE_SUBCONTRACTOR_TRANSACTION, VIEW_SUBCONTRACTOR_STATEMENT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleSubcontractor = () => {
  const [name, setName] = useState("");
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasViewContracts = useHasPermission(VIEW_CONTRACT);
  const hasViewStatement = useHasPermission(VIEW_SUBCONTRACTOR_STATEMENT);
  const hasCreateContract = useHasPermission(CREATE_CONTRACT);
  const hasCreateTransaction = useHasPermission(CREATE_SUBCONTRACTOR_TRANSACTION);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasCreateContract && {
      buttonText: "Add Contract",
      buttonIcon: WorkOutline,
      onClick: () => navigate(`/contracts/add?subcontractorId=${id}`),
    },
    hasCreateTransaction && {
      buttonText: "Add Payment",
      buttonIcon: Payment,
      onClick: () => navigate(`/transaction/add?subcontractorId=${id}`),
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Subcontractor Details"
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <SubcontractorDetails onSuccess={setName} reloadData={reload} />
        </Box>

        {/* Contract List */}
        {hasViewContracts && <ProjectSummary name={name} subcontractorId={id} reloadData={reload} />}

        {/* Transactions */}
        {hasViewStatement && (
          <SubcontractorStatement name={name} subcontractorId={id} onSuccess={handleReload} reloadData={reload} />
        )}
      </PageLayout>
    </>
  );
};
